/**
 * Цвет аватара выводится из ника — тем же принципом, что и номер гостя
 * на бэкенде: одинаковый ник всегда даёт одинаковый градиент.
 */

const PALETTE = [
    ['#e60073', '#831843'], // розовый (фирменный)
    ['#8b5cf6', '#4c1d95'], // фиолетовый
    ['#6366f1', '#312e81'], // индиго
    ['#0ea5e9', '#0c4a6e'], // голубой
    ['#14b8a6', '#134e4a'], // бирюзовый
    ['#22c55e', '#14532d'], // зелёный
    ['#eab308', '#713f12'], // янтарный
    ['#f97316', '#7c2d12'], // оранжевый
    ['#ef4444', '#7f1d1d'], // красный
    ['#f43f5e', '#881337'], // алый
];

const hashString = (str) => {
    let h = 5381;
    for (let i = 0; i < str.length; i++) {
        h = ((h << 5) + h + str.charCodeAt(i)) >>> 0;
    }
    return h;
};

export const avatarGradient = (name) => {
    const [from, to] = PALETTE[hashString(String(name || '?')) % PALETTE.length];
    return `linear-gradient(135deg, ${from}, ${to})`;
};
